import _ from "lodash";

import dateByAddingSpan from "./dateByAddingSpan";
import { timespanToApproximateSeconds } from "./timespanFunctions";

const secondsInDuration = (startDate, duration, calendar) => {
  if (!startDate || !startDate.timestamp || !duration) {
    // If there is no start date, then we need to compare approximate timespan values
    // instead of exact values.
    if (!_.isNil(duration) && !_.isNil(duration.years)) {
      return timespanToApproximateSeconds(calendar, duration);
    } else {
      return null;
    }
  }

  const endDate = dateByAddingSpan(calendar, startDate, duration);
  return endDate.timestamp - startDate.timestamp;
};

export default secondsInDuration;
